import {
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  useRecordContext,
} from 'react-admin'

const VisitRemainingListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

const Difference = () => {
  const record = useRecordContext()

  return <span>{record.contract_visits - record.visits_done}</span>
}

export const VisitRemainingList = () => (
  <List
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<VisitRemainingListFilter />}
  >
    <Datagrid
      bulkActionButtons={false}
      sort={{ field: 'co.id', order: 'DESC' }}
    >
      <TextField source="copro_code" />
      <TextField source="contract_visits" />
      <TextField source="visits_done" />
      <Difference source="difference" />
    </Datagrid>
  </List>
)
